import { useEffect, useState } from "react";
import {
  Container,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography
} from "@mui/material";

export default function TabelaPreco() {
  const [produtos, setProdutos] = useState([]);
  const [busca, setBusca] = useState("");

  useEffect(() => {
    fetch("/api/produtos")
      .then(res => res.json())
      .then(data => setProdutos(data));
  }, []);

  const filtrados = produtos.filter(p =>
    p.descricao.toLowerCase().includes(busca.toLowerCase())
  );

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Tabela de Preços
      </Typography>

      <TextField
        fullWidth
        label="Buscar produto"
        value={busca}
        onChange={e => setBusca(e.target.value)}
        sx={{ mb: 2 }}
      />

      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Código</TableCell>
              <TableCell>Produto</TableCell>
              <TableCell>Unidade</TableCell>
              <TableCell>Qtd Caixa</TableCell>
              <TableCell>Preço Unit.</TableCell>
              <TableCell>Preço Caixa</TableCell>
              <TableCell>Estoque</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filtrados.map(p => (
              <TableRow key={p.codProduto}>
                <TableCell>{p.codProduto}</TableCell>
                <TableCell>{p.descricao}</TableCell>
                <TableCell>{p.unidade}</TableCell>
                <TableCell>{p.qtdPorCaixa}</TableCell>
                <TableCell>R$ {p.precoUnidade.toFixed(2)}</TableCell>
                <TableCell>R$ {p.precoCaixa.toFixed(2)}</TableCell>
                <TableCell>{p.estoque}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
}
